const tagsToBoldSelector = (state) => state.selectedPartTags.parts;
export default tagsToBoldSelector;
